import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './LoginPage.css';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

/** Public Seite /registrieren?token=… — Einladung einlösen, Passwort setzen. */
const RegistrierenPage: React.FC = () => {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [info, setInfo] = useState<{ name: string; email: string } | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);
  const [passwort, setPasswort] = useState('');
  const [wiederholung, setWiederholung] = useState('');
  const [laedt, setLaedt] = useState(false);
  const [fertig, setFertig] = useState(false);

  useEffect(() => {
    if (!token) {
      setFehler('Kein Einladungs-Token in der URL.');
      return;
    }
    axios.get(`${API_URL}/api/auth/registrieren/${token}`)
      .then(r => setInfo(r.data))
      .catch(e => setFehler(e.response?.data?.detail || 'Einladung ungültig oder abgelaufen.'));
  }, [token]);

  const absenden = async (ev: React.FormEvent) => {
    ev.preventDefault();
    if (passwort.length < 6) {
      setFehler('Passwort muss mindestens 6 Zeichen haben.');
      return;
    }
    if (passwort !== wiederholung) {
      setFehler('Passwörter stimmen nicht überein.');
      return;
    }
    setLaedt(true);
    setFehler(null);
    try {
      await axios.post(`${API_URL}/api/auth/registrieren`, { token, passwort });
      setFertig(true);
      setTimeout(() => { window.location.href = '/'; }, 2500);
    } catch (e: any) {
      setFehler(e.response?.data?.detail || 'Registrierung fehlgeschlagen.');
    } finally {
      setLaedt(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-inner">
        <div className="login-frame">
          <span className="k-corner k-corner--tl">{'// kontor / registrierung'}</span>
          <span className="k-corner k-corner--tr">erp.live</span>
          <span className="k-corner k-corner--bl">verschlüsselt</span>
          <span className="k-corner k-corner--br">mandantengetrennt</span>

          {fertig ? (
            <div className="login-form">
              <h1 className="login-h1">Passwort gespeichert</h1>
              <p>Sie werden zum Login weitergeleitet …</p>
            </div>
          ) : info ? (
            <form className="login-form" onSubmit={absenden}>
              <h1 className="login-h1">Passwort festlegen</h1>
              <p>Für <strong>{info.name}</strong> ({info.email})</p>
              <div className="login-field">
                <label>Passwort</label>
                <input
                  type="password"
                  value={passwort}
                  onChange={e => setPasswort(e.target.value)}
                  placeholder="mind. 6 Zeichen"
                  required
                  autoFocus
                />
              </div>
              <div className="login-field">
                <label>Passwort wiederholen</label>
                <input
                  type="password"
                  value={wiederholung}
                  onChange={e => setWiederholung(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>
              {fehler && <div className="login-error">{fehler}</div>}
              <button className="login-btn" type="submit" disabled={laedt}>
                {laedt ? 'Speichere …' : 'Passwort speichern'} <span className="arr">→</span>
              </button>
            </form>
          ) : (
            <div className="login-form">
              <h1 className="login-h1">Passwort festlegen</h1>
              <div className="login-error">{fehler || 'Lade Einladung …'}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegistrierenPage;
